

















































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ViewPoliticaDePrivacidade extends Vue {
  isModalOpen = false
  pdfUrl = ''

  openModal(type: string): void {
    this.isModalOpen = true
    if (type === 'ProfissionaisDeSaude') {
      this.pdfUrl = 'https://finxstsfrontstaticfiles.blob.core.windows.net/politicas-de-privacidade/Pol%C3%ADtica%20de%20Privacidade%20I%20Profissionais%20de%20Sa%C3%BAde.pdf'
    } else if (type === 'Pacientes') {
      this.pdfUrl = 'https://finxstsfrontstaticfiles.blob.core.windows.net/politicas-de-privacidade/Pol%C3%ADtica%20de%20Privacidade%20I%20Pacientes.pdf'
    }
  }

  closeModal(): void {
    this.isModalOpen = false
    this.pdfUrl = ''
  }

  handleBackdropClick(event: MouseEvent): void {
    const target = event.target as HTMLElement
    if (target.classList.contains('modal')) {
      this.closeModal()
    }
  }
}
